import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';

interface MonthlyDataPoint {
  month: string;
  enviadas: number;
  entregues: number;
}

interface MonthlyChartProps {
  data: MonthlyDataPoint[];
}

export default function MonthlyChart({ data }: MonthlyChartProps) {
  const hasData = data.length > 0 && data.some((d) => d.enviadas > 0 || d.entregues > 0);

  return (
    <div className="bg-white dark:bg-background-100 rounded-xl border border-background-200 dark:border-background-300 p-5">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-heading font-semibold text-foreground-900 dark:text-foreground-100">Evolução Mensal</h3>
        <span className="text-xs text-foreground-400 bg-background-100 dark:bg-background-200 px-2 py-1 rounded-md">2026</span>
      </div>

      {!hasData ? (
        <div className="h-[260px] flex flex-col items-center justify-center text-foreground-400">
          <i className="ri-line-chart-line text-4xl mb-3" />
          <p className="text-sm font-medium">Sem dados ainda</p>
          <p className="text-xs mt-1">A evolução mensal aparecerá aqui conforme suas campanhas forem executadas.</p>
        </div>
      ) : (
        <div className="h-[260px]">
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart data={data}>
              <defs>
                <linearGradient id="gradSent" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="oklch(var(--primary-500))" stopOpacity={0.15} />
                  <stop offset="95%" stopColor="oklch(var(--primary-500))" stopOpacity={0} />
                </linearGradient>
                <linearGradient id="gradDelivered" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="oklch(var(--accent-500))" stopOpacity={0.15} />
                  <stop offset="95%" stopColor="oklch(var(--accent-500))" stopOpacity={0} />
                </linearGradient>
              </defs>
              <CartesianGrid strokeDasharray="3 3" stroke="oklch(var(--background-200))" vertical={false} />
              <XAxis dataKey="month" tick={{ fontSize: 12, fill: 'oklch(var(--foreground-500))' }} axisLine={false} tickLine={false} />
              <YAxis tick={{ fontSize: 12, fill: 'oklch(var(--foreground-400))' }} axisLine={false} tickLine={false} tickFormatter={(v: number) => (v >= 1000 ? `${(v / 1000).toFixed(0)}k` : v.toString())} />
              <Tooltip
                contentStyle={{
                  background: 'oklch(var(--background-50))',
                  border: '1px solid oklch(var(--background-200))',
                  borderRadius: '12px',
                  fontSize: '12px',
                  color: 'oklch(var(--foreground-900))',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.06)',
                }}
                formatter={(value: number) => [value.toLocaleString('pt-BR'), '']}
              />
              <Legend wrapperStyle={{ fontSize: '12px', paddingTop: '10px' }} />
              <Area type="monotone" dataKey="enviadas" name="Enviadas" stroke="oklch(var(--primary-500))" fill="url(#gradSent)" strokeWidth={2} />
              <Area type="monotone" dataKey="entregues" name="Entregues" stroke="oklch(var(--accent-500))" fill="url(#gradDelivered)" strokeWidth={2} />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
}